import { Stack, Card, CardHeader, IconButton, CardContent, FormControl, InputLabel, Select, MenuItem, Tooltip, SelectChangeEvent, Typography } from "@mui/material";
import { SelectVillage } from "../../components/SelectVillage";
import { Asset } from "../../data/Asset";
import RefreshIcon from '@mui/icons-material/Refresh';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import { Dashboard } from "../../enums/Dashboard";
import { useContext, useState } from "react";
import { SelectDoor } from "./SelectDoor";
import { SelectDayCategory } from "./SelectDayCategory";
import VspPortalContext from "../../store/VspPortalContext";
import { VspPortalActions } from "../../store/VspPortalActions";


type SelectDoorScheduleProps = {

    onDayCategoryNameChange: (value: string) => void,
    onDoorCodeChange: (value: string) => void,
    onVillageCodeChange: (value: string) => void,

}


export const SelectDoorSchedule: React.FC< SelectDoorScheduleProps > = ( props: SelectDoorScheduleProps ) => {

    const { onDayCategoryNameChange, onDoorCodeChange, onVillageCodeChange } = props;

    const [ village, setVillage ] = useState< string >( '' );
    const [ dayCategory, setDayCategory ] = useState<string>( '' );
    const [ door, setDoor ] = useState<string>( '' );

    const { dispatch } = useContext( VspPortalContext );

    
    const handleResetClick = ( ) => {

        setDoor( '' );
        setDayCategory( '' );
        setVillage( '' );

        onDayCategoryNameChange( '') ;
        onDoorCodeChange( '' );
        onVillageCodeChange( '' );

        dispatch({ type: VspPortalActions.SetSchedule, payload: undefined });

    };

    const handleSelectDayCategory = ( value: string ) => {
        
        setDayCategory( value );
        onDayCategoryNameChange( value );   

    };


    const handleSelectDoor = ( value: string ) => {

        setDoor( value );
        setDayCategory( '' );
        
        onDoorCodeChange( value );

    };


    const handleVillageCodeChange = ( value: string ) => {

        setVillage( value );
        setDoor( '' );
        setDayCategory( '' );

        onVillageCodeChange( value );

    };

    return (
        <Stack direction="row" display="flex" justifyContent="center" gap={ 0.5 } sx={{ marginTop: '50px' }}>

            <Card sx={{ maxWidth: 'fit-content', boxShadow: 5 }}>

                <CardHeader 
                    sx={{ fontWeight: '600', fontSize: '20px', paddingTop: '5px', paddingBottom: '0' }}
                    title="Search Parameters"
                    avatar={ <ContentPasteSearchIcon /> }
                    action={
                        <Tooltip title="Reset">
                            <IconButton onClick={ handleResetClick }>
                                <RefreshIcon />
                            </IconButton>
                        </Tooltip>
                    }
                />

                <CardContent>

                    <Stack direction="row" gap={ 1 } display="flex" alignItems="center" >
                        
                        <SelectVillage asset={ Asset.Waio } dashboard={ Dashboard.Spoke } onSelectVillage={ handleVillageCodeChange } village={ village } width={ '200px' } />
                        
                        <SelectDoor disabled={ !village } onSelectDoor={ handleSelectDoor } village={ village } width={ '200px' }/>

                        <SelectDayCategory disabled={ !village || !door } onSelectDayCategory={ handleSelectDayCategory } village={ village } doorCode={ door } width={ '200px' } />

                    </Stack>

                </CardContent>

            </Card>

        </Stack>
    );

};